<template lang="">
  <div class='photo'>
    <p class='title'>{{ $t('photowall.title') }}</p>
    <div :class="['content',{active:isPad}]">
      <div class='content-left' v-show='!isPad'>
        <img class='foot-img-280' src="https://static.lespark.cn/pc_img/images/foot/1.png" alt="">
        <ul>
          <li> <img class='foot-img-135' src="https://static.lespark.cn/pc_img/images/foot/9.png" alt="">
            <img class='foot-img-w135' src="https://static.lespark.cn/pc_img/images/foot/10.png" alt="">
          </li>
          <li> <img class='foot-img-w135' src="https://static.lespark.cn/pc_img/images/foot/13.png" alt="">
            <img class='foot-img-135' src="https://static.lespark.cn/pc_img/images/foot/14.png" alt="">
          </li>
        </ul>
      </div>
      <div class='content-right' :class="{'en-center':enCenter}">
        <ul class='content-right-top'>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/2.png" alt=""> </li>
          <!-- <li> <img src="https://static.lespark.cn/pc_img/images/foot/3.png" alt=""> </li> -->
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/4.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/5.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/6.png" alt=""> </li>
          <li> <img class='foot-img-w280' src="https://static.lespark.cn/pc_img/images/foot/7.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/8.png" alt=""> </li>
        </ul>
        <ul class='content-right-center'>
          <li class='online-7'>
            <div>{{ $t('photowall.LaunchedYears') }}</div>
            <div v-html="$t('photowall.millionsWomen')"></div>
          </li>
          <li class='worldwide'>
            <img src="https://static.lespark.cn/pc_img/images/foot/logo-m.png" alt="">
            <p>{{ $t('photowall.content1') }}</p>
            <p>{{ $t('photowall.content2') }}</p>
          </li>
          <li class='couples'>
            <div v-html="$t('photowall.content3')"></div>
            <div v-html="$t('photowall.content4')"></div>
          </li>
          <li class='couples-photo'>
            <img src="https://static.lespark.cn/pc_img/images/foot/11.png" alt=""><img src="https://static.lespark.cn/pc_img/images/foot/12.png" alt="">
          </li>
        </ul>
        <ul class='foot-bottom'>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/15.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/17.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/18.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/19.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/20.png" alt=""> </li>
          <li> <img src="https://static.lespark.cn/pc_img/images/foot/21.png" alt=""> </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import util from 'Common/util';
  export default {
    name: 'photo',
    data() {
      return {
        imgData: [],
        isPad: false,
        enCenter:false,
      }
    },
    created() {
      const that = this
      if (document.documentElement.clientWidth <= 1400) {
          that.isPad = true
        } else {
          that.isPad = false
        }

      let _arg = util.getQueryStringArgs();
      if (_arg.lang == 'zh-Hans-TW') {
        that.enCenter = false
      } else if (_arg.lang == 'zh-Hant-TW') {
        that.enCenter = false
      } else if (_arg.lang == 'en') {
        that.enCenter = true
      }
    },
    mounted() {
      const that = this
      window.addEventListener('resize', util.debounce(that.changePhoto,1000))
    },
    methods: {
      changePhoto(){
        const that = this
        if (document.documentElement.clientWidth <= 1400) {
          that.isPad = true
        } else {
          that.isPad = false
        }
    },
  }
  }
</script>
<style scoped lang="">
  .photo {
    max-width: 1400px;
    min-width: 960px;
    margin: 0 auto 75px;
    position: relative;
  }

  .title {
    height: 180px;
    line-height: 180px;
    font-size: 38px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #333333;
    letter-spacing: 1px;
    text-align: center;
  }

  .content {
    box-sizing: border-box;
    max-width: 1400px;
    min-width: 960px;
    height: 768px;
    background: #F7F7F7;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content-left {
    width: 280px;
    height: 725px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .content-left>ul {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .content-left>ul>li {
    display: flex;
    flex-direction: column;
  }

  .content-left img {
    margin-bottom: 10px;
    border-radius: 8px;
  }

  .foot-img-280 {
    width: 280px;
    height: 280px;
  }

  .foot-img-135 {
    width: 135px;
    height: 135px;
  }

  .foot-img-w135 {
    width: 135px;
    height: 280px;
  }

  .content-right {
    width: 1100px;
    height: 725px;
    min-width: 960px;
  }

  .en-center{
    text-align: center;
  }

  .content-right-top img {
    width: 135px;
    height: 135px;
    border-radius: 8px;
  }

  .content-right-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .foot-img-w280 {
    width: 280px !important;
  }

  .content-right-center {
    height: 422px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }

  .online-7 {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    width: 170px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #FFFFFF;
    letter-spacing: 1px;
  }

  .online-7>div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 206px;
    font-size: 24px;
  }

  .online-7>div:first-child {
    background: linear-gradient(226deg, #FFCE49 0%, #FF40F4 100%);
    border-radius: 8px;
  }

  .online-7>div:last-child {
    background: linear-gradient(47deg, #2B96FB 0%, #93ACFF 100%);
    border-radius: 8px;
  }

  .worldwide {
    width: 420px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 44px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #333333;
    background: #FFFFFF;
    letter-spacing: 1px;
  }

  .worldwide>img {
    width: 118px;
    height: 118px;
    margin-bottom: 20px;
  }

  .couples {
    width: 170px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  .couples>div {
    width: 170px;
    height: 206px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #FFFFFF;
    letter-spacing: 1px;
    font-size: 24px;
  }

  .couples>div:first-child {
    background: linear-gradient(46deg, #86D96A 0%, #1DDDD3 100%);
  }

  .couples>div:last-child {
    background: linear-gradient(42deg, #FD2B6D 0%, #FFD28D 100%);
  }

  .couples-photo {
    width: 280px;
    height: 100%;
  }

  .couples-photo>img {
    border-radius: 8px;
    width: 280px;
  }
  .foot-bottom {
    height: 135px;
    display: flex;
    justify-content: space-between;
  }

  .foot-bottom img {
    border-radius: 8px;
    height: 100%;
  }
  .active{
    justify-content: center;
  }
  .active .content-right{
    padding: 0 20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/photowall.vue